import { useLazyQuery } from "@apollo/client";
import { FETCH_INSTANCE_SALES_DESCRIPTIONS as fetchInstanceSalesDescriptions } from "../../../../graphql/query/Instance";
import { Button } from "../../../../components/ui";
import {
  buildInstanceDescriptionsInput,
  copyTextToClipboard,
} from "./CopyDescriptionBody";

export const formatSalesPrice = value => {
  if (value?.value == null) return null;
  const amount = Number(value.value).toLocaleString("en-US");
  const code = value.currency?.code || "";
  return `${code} ${amount} plus applicable taxes`.trim();
};

export const buildSalesDescription = (edges = []) =>
  edges
    .map(edge =>
      [edge?.description, formatSalesPrice(edge?.value)]
        .filter(Boolean)
        .join("\n\n"),
    )
    .filter(Boolean)
    .join("\n\n");

const CopySalesDescriptionBody = props => {
  const { closeModal, instance, ids } = props;
  const [fetchInstanceSalesDescription, { loading }] = useLazyQuery(
    fetchInstanceSalesDescriptions(),
  );

  const handleClick = async () => {
    const input = buildInstanceDescriptionsInput({ ids, instance });

    const result = await fetchInstanceSalesDescription({
      variables: { input },
    });
    const edges = result?.data?.instancesV2?.edges || [];
    const description = buildSalesDescription(edges);

    await copyTextToClipboard(description);
    closeModal();
  };

  return (
    <div className="mt-4 flex">
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        autoFocus
        disabled={loading}
        label={loading ? "Fetching description" : "Copy sales description"}
        onClick={handleClick}
      />
    </div>
  );
};

export default CopySalesDescriptionBody;
